import _ from 'lodash';
import getFormLocal from './getFormLocal';
import getQuestions from './getQuestions';

export default function calculateProgress(formId, sectionId = null) {
  return new Promise((resolve) => {
    getFormLocal(formId).then(async (form) => {
      let allSections = [];
      if (sectionId) {
        allSections = [sectionId];
      } else {
        allSections = form?.inspection?.children ? Object.keys(form.inspection.children) : [];
      }

      const finalArray = allSections.map(async (_sectionId) => {
        const questions = await getQuestions(formId, _sectionId);
        let filledQuestion = _.filter(questions, 'required');
        let filledQuestionCount = 0;
        let questionCount = 0;

        if (filledQuestion.length === 0) {
          filledQuestion = _.filter(questions, 'value');
          if (questions.length === filledQuestion.length) return { [_sectionId]: 100 };
        }

        filledQuestion.forEach((question) => {
          if ((question.displayed !== undefined && !question.displayed) || !question.required || question.hide) {
            return;
          }
          questionCount += 1;
          const { value } = question;
          if (value && value !== null && value !== undefined && value !== '') {
            filledQuestionCount += 1;
          }
        });

        const sectionProgress = Math.floor((filledQuestionCount / questionCount) * 100);
        const finalValue = { [_sectionId]: sectionProgress };
        return finalValue; // important to return the value
      });
      const resolvedFinalArray = await Promise.all(finalArray);
      const result = {};
      resolvedFinalArray.map((content) => {
        Object.assign(result, content);
        return true;
      });
      resolve(result);
    });
  });
}
